import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import {IAfterGuiAttachedParams, ICellRendererParams} from 'ag-grid-community';

@Component({
    selector: 'app-checkbox-renderer',
    templateUrl: './checkbox-renderer.component.html',
    styleUrls: ['./checkbox-renderer.component.css'],
    standalone: false
})
export class CheckboxRendererComponent implements AgRendererComponent, OnInit {
  params: any;
  refresh(params: any): boolean {
    return false;
  }
  agInit(params: ICellRendererParams): void {
    this.params = params;
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
  }
  constructor() { }

  ngOnInit() {
  }

}
